import React from "react";

/**
 * Renders an eye icon as an SVG component.
 *
 * @param {object} cls - The class name for styling the SVG.
 * @return {JSX.Element} The rendered SVG eye icon.
 */
export const ActionEyeIcon = ({ cls }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={cls}
    >
      <path
        d="M20.4501 10.065C19.2873 8.17117 16.6423 4.99385 12 4.99385C7.35772 4.99385 4.7127 8.17117 3.54988 10.065C3.19041 10.6464 3 11.3164 3 12C3 12.6836 3.19041 13.3536 3.54988 13.935C4.7127 15.8288 7.35772 19.0062 12 19.0062C16.6423 19.0062 19.2873 15.8288 20.4501 13.935C20.8096 13.3536 21 12.6836 21 12C21 11.3164 20.8096 10.6464 20.4501 10.065ZM19.1718 13.1501C18.1732 14.774 15.9128 17.5067 12 17.5067C8.0872 17.5067 5.82679 14.774 4.82816 13.1501C4.61459 12.8045 4.50147 12.4063 4.50147 12C4.50147 11.5938 4.61459 11.1955 4.82816 10.8499C5.82679 9.22603 8.0872 6.4933 12 6.4933C15.9128 6.4933 18.1732 9.22303 19.1718 10.8499C19.3854 11.1955 19.4985 11.5938 19.4985 12C19.4985 12.4063 19.3854 12.8045 19.1718 13.1501Z"
        fill="currentColor"
      />
      <path
        d="M12.0006 8.25339C11.2592 8.25339 10.5344 8.47324 9.91795 8.88514C9.30149 9.29704 8.82102 9.8825 8.5373 10.5675C8.25358 11.2524 8.17934 12.0062 8.32398 12.7333C8.46862 13.4605 8.82564 14.1284 9.3499 14.6527C9.87415 15.1769 10.5421 15.5339 11.2692 15.6786C11.9964 15.8232 12.7501 15.749 13.4351 15.4653C14.1201 15.1815 14.7055 14.7011 15.1174 14.0846C15.5293 13.4682 15.7492 12.7434 15.7492 12.002C15.748 11.0082 15.3527 10.0554 14.6499 9.35265C13.9472 8.6499 12.9944 8.25458 12.0006 8.25339ZM12.0006 14.2512C11.5557 14.2512 11.1209 14.1193 10.751 13.8721C10.3811 13.625 10.0928 13.2737 9.92261 12.8627C9.75237 12.4517 9.70783 11.9995 9.79462 11.5632C9.8814 11.1269 10.0956 10.7261 10.4102 10.4116C10.7247 10.097 11.1255 9.88283 11.5618 9.79605C11.9981 9.70926 12.4503 9.75381 12.8613 9.92404C13.2723 10.0943 13.6235 10.3826 13.8707 10.7524C14.1178 11.1223 14.2497 11.5572 14.2497 12.002C14.2497 12.5985 14.0128 13.1706 13.591 13.5924C13.1692 14.0142 12.5971 14.2512 12.0006 14.2512Z"
        fill="currentColor"
      />
    </svg>
  );
};
